import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/cart'

export default {
  /**
   * Add an item to the cart
   * @param {Object} payload - The item to add
   * @returns {Promise} The result of the request
   */
  addItem(payload, params = {}) {
    return $fetch.peg(ENDPOINT, {
      method: 'POST',
      body: payload,
      params,
    })
  },
  /**
   * Get the current user's cart
   * @param {Object} params - Query parameters, like zip code
   * @param {Object} options - Fetch options
   * @returns {Promise<Array>} The user's cart items
   */
  get(params = {}, options = {}) {
    return $fetch.peg(ENDPOINT, { params, ...options })
  },
  /**
   * Remove an item from the cart
   * @param {string} id - The ID of the item to remove
   * @returns {Promise} The result of the request
   */
  removeItem(id, params = {}) {
    return $fetch.peg(`${ENDPOINT}/${id}`, {
      method: 'DELETE',
      params,
    })
  },
}
